import networkTS from '@/misc/apis/networkTS'

const DEFAULT_ATTEMPTS = 10
const DEFAULT_INTERVAL_MS = 500

function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * Waits until the search read model has caught up with the given entities.
 *
 * The read model is updated asynchronously, so a list request issued right after a mutation
 * can still return stale data. Polling `updateOngoing` replaces the fixed delay that the
 * Algolia-based refresh helper used.
 */
export async function awaitSearchIndexUpdate(
  entityIds: string[],
  { attempts = DEFAULT_ATTEMPTS, intervalMs = DEFAULT_INTERVAL_MS } = {}
): Promise<void> {
  if (!entityIds || entityIds.length === 0) {
    await sleep(intervalMs)
    return
  }
  for (let attempt = 0; attempt < attempts; attempt++) {
    try {
      const response = await networkTS.searchServiceUpdateOngoing({ entityIds })
      if (!response.data?.ongoing) {
        return
      }
    } catch (e) {
      // The caller still reloads afterwards, so a failed probe should not block the flow.
      return
    }
    await sleep(intervalMs)
  }
}
